import { render } from "./simage.vue?vue&type=template&id=16272372"
import script from "./simage.vue?vue&type=script&lang=js"
export * from "./simage.vue?vue&type=script&lang=js"

import "./simage.vue?vue&type=style&index=0&id=16272372&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__